export default "__VITE_ASSET__CnpuSCgB__"